import { TranslationsTypes, translations } from '@app/models';

export function createTranslation(word: string): TranslationsTypes {
    if (word in translations) {
        return word as TranslationsTypes;
    }
    return '';
}

export const interpolateTranslation = (translation: string, interpolation: string[]): string => {
    let interpolated: string = translation;

    interpolation.forEach((item: string, i: number) => {
        const index: string = `||${i}||`;
        interpolated = interpolated.replace(index, item);
    });

    return interpolated;
};
